import { Component, OnInit, ViewChild, ElementRef } from "@angular/core";
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";
import { ActivatedRoute, Router } from "@angular/router";
import { EnterpriseService } from "../../enterprise.service";
import * as XLSX from "xlsx";
@Component({
  selector: "app-trips",
  templateUrl: "./trips.component.html",
  styleUrls: ["./trips.component.sass"],
})
export class TripsComponent implements OnInit {
  constructor(
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private enterpriseService: EnterpriseService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
  ) {}

  trips: any[] = [];
  allTrips: any[] = [];
  page = 1;
  limit = 6;
  totalPages = 0;
  totalRecords = 0;
  enterpriseID = "";
  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe((params) => {
      this.enterpriseID = params["id"];
      console.log("enterpriseID ", this.enterpriseID);
    });
    this.getPaginatedTrips();
  }

  getPaginatedTrips() {
    this.spinner.show();

    const data = {
      page: this.page,
      limit: this.limit,
      enterpriseId: this.enterpriseID,
    };

    this.enterpriseService.getTrips(data).subscribe(
      (res: any) => {
        this.spinner.hide();

        if (res.statusCode === 200) {
          this.trips = res.data; // ✅ FIXED
          console.log("trips", this.trips);
          // ✅ pagination mapping
          this.totalRecords = res.pagination.total;
          this.totalPages = res.pagination.totalPages;
          this.page = res.pagination.page;
          this.limit = res.pagination.limit;
        } else {
          this.toastr.error(res.message);
        }
      },
      (err) => {
        this.spinner.hide();
        this.toastr.error(err.message);
      },
    );
  }

  gty(page) {
    this.page = page;
    this.getPaginatedTrips();
  }

  statusMap: any = {
    1: "Pending",
    2: "Accepted",
    3: "Started",
    4: "Completed",
    5: "Cancelled",
    6: "Driver Cancel",
  };

  viewTrip(trip: any) {
    const id = trip._id;
    this.router.navigate(["dashboard/enterprise-view-trip"], {
      queryParams: { id },
    });
  }
  trackTrip(trip: any) {
    const id = trip._id;
    this.router.navigate(["dashboard/enterprise-track-trip"], {
      queryParams: { id },
    });
  }

  getAllTrips() {
    this.spinner.show();

    const data = {
      page: 1,
      limit: this.totalRecords,
      enterpriseId: this.enterpriseID,
    };

    this.enterpriseService.getTrips(data).subscribe(
      (res: any) => {
        this.spinner.hide();

        if (res.statusCode === 200) {
          this.allTrips = res.data;
        } else {
          this.toastr.error(res.message);
        }
      },
      (err) => {
        this.spinner.hide();
        this.toastr.error(err.message);
      },
    );
  }

  formatTripsForExcel(trips: any[]) {
    return trips.map((trip) => ({
      "Trip Code": trip.tripCode,
      Status: this.statusMap[trip.status] || "Unknown",
      "Distance (KM)": trip.totalDistance,
      "Duration (Min)": trip.totalDuration,
      "Total Stops": trip?.stops?.length ? trip.stops.length - 1 : 0,
      "Vehicle Type": trip?.estimatedCost?.data?.vehicleType || "",
      "Trip Fare": trip?.estimatedCost?.data?.discountedTripFare || "",

      "Driver Amount": trip.driverReceivingAmount,

      "Enterprise Email": trip?.enterpriseDetails?.email || "",
      "Enterprise Phone": trip?.enterpriseDetails?.phone || "",

      "Driver Name": trip?.driverDetails
        ? `${trip.driverDetails.firstName} ${trip.driverDetails.lastName}`
        : "",
      "Driver Phone": trip?.driverDetails?.phoneNumber || "",
      "Vehicle Number": trip?.driverDetails?.vehicleNumber || "",

      "Cancel Reason": trip.cancelReason || "",
      "Created At": new Date(trip.createdAt).toLocaleString(),
    }));
  }

  exportCurrentToExcel() {
    if (!this.trips?.length) return;

    const excelData = this.formatTripsForExcel(this.trips);

    const worksheet = XLSX.utils.json_to_sheet(excelData);
    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet, "Current Trips");
    XLSX.writeFile(workbook, "Enterprise_Trips_Current.xlsx");
  }

  exportAllToExcel() {
    this.enterpriseService
      .getTrips({ page: 1, limit: this.totalRecords, enterpriseId: this.enterpriseID, })
      .subscribe((res: any) => {
        if (!res?.data?.length) return;

        const excelData = this.formatTripsForExcel(res.data);

        const worksheet = XLSX.utils.json_to_sheet(excelData);
        const workbook = XLSX.utils.book_new();

        XLSX.utils.book_append_sheet(workbook, worksheet, "All Trips");
        XLSX.writeFile(workbook, "Enterprise_Trips_All.xlsx");
      });
  }
}
